import { createContext, useContext, useState, useCallback } from "react";

const LayoutContext = createContext(null);

export function LayoutProvider({ children }) {
  const [headerContent, setHeaderContent] = useState(null);

  const setHeader = useCallback((content) => {
    setHeaderContent(content);
  }, []);

  const clearHeader = useCallback(() => {
    setHeaderContent(null);
  }, []);

  return (
    <LayoutContext.Provider value={{ headerContent, setHeader, clearHeader }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const ctx = useContext(LayoutContext);
  if (!ctx) throw new Error("useLayout must be used within LayoutProvider");
  return ctx;
}

export default LayoutContext;
